import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';
import aplCatlCode from '@/json/aplCatlCode';
const aplCatl = aplCatlCode.ENOTICE;

export const routesMultiEnotifyApply = [{
    path: 'multi-enotify-terms',
    name: routeName.MULTI_ENOTIFY_TERMS,
    component: () => import('@/views/aplCatlMultiENotify/landingPage/Index.vue'),
    meta: { auth: true, metaTitle: '申請電子通知單說明', leaveAlert: true, code: 'multiENotify', unableBack: true, pageTitle: '申請電子通知單' },
    beforeEnter: (to, from, next) => {
        const whiteList = [routeName.EDIT_TEL_MAIL];
        const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
        next(guideRoute);
    },
},
{
    path: 'multi-enotify',
    name: routeName.MULTI_ENOTIFY,
    component: () => import('@/views/aplCatlMultiENotify/dataChange/Index.vue'),
    meta: { auth: true, metaTitle: '申請電子通知單', leaveAlert: true, code: 'multiENotify', unableBack: true, pageTitle: '申請電子通知單' },
    beforeEnter: (to, from, next) => {
        const whiteList = [routeName.MULTI_ENOTIFY_TERMS, routeName.CONFIRM_DATA];
        const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
        next(guideRoute);
    },
}];
